module.exports = __webpack_public_path__ + "static/media/logowanie-web.23f67d40.png";